export enum FilterNavType {
  Calories = 'Calories',
  Allergens = 'Allergens',
}
